import { formatCurrency } from '@/lib/helpers/format-currency';
import type { ReferralActivityItem } from '@/types/referral';
import {
  formatRelativeTime,
  referralAvatarColor,
  referralInitials,
} from '../utils';

interface ActivityFeedProps {
  activity: ReferralActivityItem[];
}

export const ActivityFeed = ({ activity }: ActivityFeedProps) => {
  return (
    <div className="activity-card">
      <div className="activity-h">
        <span className="live-dot" />
        <h3 className="rne-h3" style={{ flex: 1, fontSize: 15 }}>
          Live activity
        </h3>
        <span className="rne-meta" style={{ fontSize: 12 }}>
          Across the Sellyt network
        </span>
      </div>
      <div className="activity-list">
        {activity.length === 0 ? (
          <div className="activity-item">
            <div className="body">
              <div className="t">
                No activity yet. Share your link to get started.
              </div>
            </div>
          </div>
        ) : (
          activity.slice(0, 8).map((item) => {
            const name = item.referralName || 'Vendor';
            const hasAmount =
              typeof item.amount === 'number' && item.amount > 0;

            return (
              <div key={item.id} className="activity-item">
                <div className="av-w">
                  <div
                    className="av av-40"
                    style={{ background: referralAvatarColor(name) }}
                  >
                    {referralInitials(name)}
                  </div>
                  {hasAmount && <span className="badge">₦</span>}
                </div>
                <div className="body">
                  <div className="t">
                    {item.referralName && <strong>{item.referralName}</strong>}{' '}
                    {item.message}
                    {hasAmount && (
                      <span className="amt">
                        {formatCurrency(item.amount!)}
                      </span>
                    )}
                  </div>
                  <div className="ago">
                    {formatRelativeTime(item.createdAt)}
                  </div>
                </div>
                {!item.isRead && <span className="new-dot" />}
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};
